export default __webpack_public_path__ + "static/media/app_store.8ab36fc2.png";